// Module
var code = "<article class=\"message is-success\"> <div class=\"message-header\"> <p>Well done! You have successfully connected your zenflow account with Xero.</p> </div> <div class=\"message-body\"> See the Xero entities available below </div> </article>";
// Exports
export default code;